import React, { useContext, useEffect, useState } from 'react';
import { CAFormType } from 'src/models/clinicalAssesment/clinicalAssesment';
import { MeetingData } from 'src/models/MeetingData';
import { FormVersionService } from 'src/services/FormVersionService';
import { TherapistService } from 'src/services/TherapistService';
import { VideoChatService } from 'src/services/VideoChatService';
import { toast } from "react-toastify";
import AiIcon from "../../../assets/images/icons/AI_animation_logo.gif";
import { Button, Collapse, Modal, ModalHeader, ModalBody, Input, Label, Card, CardBody, FormGroup, Alert } from 'reactstrap';
import moment from 'moment';
import { TPType } from 'src/models/therapyPlan/therapyPlan';
import ClinicalAssessmentPdfModal from 'src/pages/Popup/ClinicalAssessmentPdfModal';
import NewClinicalAssessmentPdfModal from 'src/pages/Popup/NewClinicalAssessmentPdfModal';
import ClinicalAssetmentModal from 'src/pages/Popup/ClinicalAssessmentModal';
import NewClinicalAssessmentModal from 'src/pages/Popup/NewClinicalAssessmentModal';
import Spinner from "../../../common/spinner/spinner";
import UserContext from 'src/context/UserContext';
import AIGeneratedAssessment from 'src/pages/NewAssessmentDigitalForm/AIGeneratedAssessment';

interface AssessmentClientSaasProps {
  clientId: string;
}
const AssessmentClientSaas: React.FC<AssessmentClientSaasProps> = ({ clientId }) => {
  const [selectedCAFormType, setSelectedCAFormType] = useState("");
  const [firstMeetingData, setFirstMeetingData] = useState<any>([]);
  const [firstMeetingData2, setFirstMeetingData2] = useState<any>(null);
  const [clinicalAssessmentInfo, setClinicalAssessmentInfo] = useState<any>();
  const [showClinicalAssessmentWithVersionModal, setShowClinicalAssessmentWithVersionModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showNewClinicalAssessmentModal, setShowNewClinicalAssessmentModal] = useState<boolean>(false);
  const [showAiGeneratedAssessmentPopup, setShowAiGeneratedAssessmentPopup] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showClinicalAssessmentModal, setShowClinicalAssessmentModal] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState(false);
  const [clinicalAssessmentId, setClinicalAssessmentId] = useState("");
  const [clinicalAssessmentType, setClinicalAssessmentType] = useState("");
  const [showClinicalAssessmentPdfModal, setShowClinicalAssessmentPdfModal] = useState<boolean>(false);
  const [showNewClinicalAssessmentPdfModal, setShowNewClinicalAssessmentPdfModal] = useState<boolean>(false);
  const [expandedPlans, setExpandedPlans] = useState<{ [key: string]: boolean }>({});
  const [showTestModal, setShowTestModal] = useState<boolean>(false);
  const [transcriptData, setTranscriptData] = useState<string[]>([]);
  const [speakerMapping, setSpeakerMapping] = useState<{ [key: string]: string }>({});
  const [isLoadingTranscript, setIsLoadingTranscript] = useState<boolean>(false);
  const [validationError, setValidationError] = useState<string>("");
  const [isMappingSubmitted, setIsMappingSubmitted] = useState<boolean>(false);
  const eventType = "DOWNLOAD";
  const [loggedUser] = useContext(UserContext);

  useEffect(() => {
    if (clientId) {
      handleClinicalAssessmentView();
    }
  }, [])

  const handleClinicalAssessmentView = async () => {
    if (clientId != undefined) {
      setIsLoading(true);
      setSelectedCAFormType("");
      setFirstMeetingData([] as MeetingData[]);
      setFirstMeetingData2(null);

      const result = await fetchClinicalAssessmentWithVersions(clientId);
      if (result.success) {
        setClinicalAssessmentInfo(result.data);
        setShowClinicalAssessmentWithVersionModal(true);
        setIsLoading(false);
      }else {
       /* toast("Error loading data", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });*/
        setIsLoading(false);
      }
    }
  };

  const fetchClinicalAssessmentWithVersions = async (clientId: string) => {
    try {
      const res = await FormVersionService.getClinicalAssessmentsWithAllVersions(clientId);

      if (res && res.success) {
        const { relatedCAFormType, caWithVersion, daWithVersion, meetingData } = res.data;

        if (relatedCAFormType == CAFormType.OLD_CA) {

          setSelectedCAFormType(CAFormType.OLD_CA);
          return { success: true, data: caWithVersion };

        } else if (relatedCAFormType == CAFormType.NEW_CA) {

          setSelectedCAFormType(CAFormType.NEW_CA);
          if (daWithVersion.length == 0 && meetingData) {
            setFirstMeetingData(meetingData);
          }
          // Set firstMeetingData2 for AI button when there's existing assessment
          if (daWithVersion.length >= 1 && meetingData) {
            setFirstMeetingData2(meetingData);
          }
          return { success: true, data: daWithVersion };

        } else {
          return { success: false };
        }
      } else {
        toast.error("Encountered an error while retrieving the assessment data with versions!", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        return { success: false };
      }

    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
      return { success: false };
    }
  };
  const openClinicalAssessment = () => {
    if (selectedCAFormType === CAFormType.OLD_CA) {
      setShowNewClinicalAssessmentModal(false);
      setShowClinicalAssessmentModal(true);
    } else if (selectedCAFormType === CAFormType.NEW_CA) {
      setShowClinicalAssessmentModal(false);
      setShowNewClinicalAssessmentModal(true);
    }
  };
  const generateAiAssessmentFunction = () => {
    setShowAiGeneratedAssessmentPopup(true);
  }

  const handleChildFunction = (isCalled: boolean) => {
    setShowAiGeneratedAssessmentPopup(isCalled);
  };

  const handleAIGenerateClick = () => {
    setIsLoading(true);
    generateAiAssessmentFunction();
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  };

  const handleReGenerateAIClick = async () => {
    let meetingId;
    meetingId=firstMeetingData2?.meetingId
    console.log({meetingId});
    if(!meetingId && loggedUser?._id == "62f17eb1b81f31a68505d9ad"){
      meetingId = "fake-meetingId";
    }
    if (!meetingId) {
        toast.error("Meeting ID not found!", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        return;
    }

    setIsLoading(true);
    try {
      const response = await TherapistService.generateOpenAIAssessment(meetingId);
      if (response?.success) {
        toast.success("AI Clinical Assessment generated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        // Refresh the assessment list
        const result = await fetchClinicalAssessmentWithVersions(clientId);
        if (result.success) {
          setClinicalAssessmentInfo(result.data);
          // Auto-open the Clinical Assessment modal after successful generation
          setTimeout(() => {
            openClinicalAssessment();
          }, 500); // Small delay to ensure state is updated
        }
      } else {
        toast.error("Failed to generate AI Clinical Assessment!", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
      }
    } catch (error) {
      console.error("Error generating AI assessment:", error);
      toast.error("Something went wrong while generating AI assessment!", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const formatDate = (date: any) => {
    if (!date) return '';
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  };
  const generateClinicalPdf = (planId: string, tpType: TPType) => {
    setClinicalAssessmentId(planId);
    setClinicalAssessmentType(tpType);
    if (selectedCAFormType === CAFormType.OLD_CA) {
      setShowClinicalAssessmentPdfModal(true);
    } else if (selectedCAFormType === CAFormType.NEW_CA) {
      setShowNewClinicalAssessmentPdfModal(true);
    }
  };
  const toggleVersions = (planId: string) => {
    setExpandedPlans(prev => ({
      ...prev,
      [planId]: !prev[planId]
    }));
  };

  const handleTestClick = async () => {
    setShowTestModal(true);
    await loadTranscriptData();
  };

  const closeTestModal = () => {
    setShowTestModal(false);
    setTranscriptData([]);
    setSpeakerMapping({});
    setValidationError("");
    setIsMappingSubmitted(false);
  };

  // Available real names for mapping
  const availableNames = [
    "Dr. Sarah Johnson (Therapist)",
    "Emily Chen (Client)",
    "Michael Chen (Family Member)"
  ];

  const getMockTranscriptData = () => {
    return [
      "user1: Hello, how are you feeling today?",
      "user2: I've been feeling quite anxious lately, especially about work.",
      "user1: Can you tell me more about what specifically at work is causing you anxiety?",
      "user2: Well, I have this big presentation coming up next week and I keep worrying about it.",
      "user3: Mom, you always worry too much about these things.",
      "user2: I know, but I can't help it. The last time I presented, it didn't go well.",
      "user1: It sounds like you're carrying some past experiences into this new situation. That's very common.",
      "user2: Yes, exactly. I keep thinking about all the things that could go wrong.",
      "user1: Let's work on some techniques to help manage those anxious thoughts. Have you tried breathing exercises?",
      "user2: A little bit, but I'm not sure I'm doing them correctly.",
      "user3: I can help you practice at home if you want.",
      "user1: That's wonderful support. Family involvement can be very helpful in managing anxiety.",
      "user2: Thank you both. I really appreciate the help.",
      "user1: We'll continue working on this together. How does that sound?",
      "user2: That sounds great. I'm feeling a bit more hopeful already."
    ];
  };

  const loadTranscriptData = async () => {
    setIsLoadingTranscript(true);

    // Try to load real transcript data first
    if (firstMeetingData2?.transcribeId) {
      try {
        const response = await VideoChatService.getTranscribeDetails(firstMeetingData2.transcribeId);
        if (response.success && response.data.transcriptText && response.data.transcriptText.length > 0) {
          setTranscriptData(response.data.transcriptText);
          // Extract unique speakers from transcript
          const speakers = extractSpeakersFromTranscript(response.data.transcriptText);
          // Initialize speaker mapping with empty values
          const initialMapping: { [key: string]: string } = {};
          speakers.forEach(speaker => {
            initialMapping[speaker] = ""; // Default to empty for selection
          });
          setSpeakerMapping(initialMapping);
          setIsLoadingTranscript(false);
          return;
        }
      } catch (error) {
        console.error("Error loading transcript:", error);
      }
    }

    // If no real data available, use mock data
    toast.info("Using mock transcript data for demonstration", {
      position: toast.POSITION.TOP_RIGHT,
      className: "foo-bar",
    });

    const mockData = getMockTranscriptData();
    setTranscriptData(mockData);

    // Extract unique speakers from mock transcript
    const speakers = extractSpeakersFromTranscript(mockData);
    // Initialize speaker mapping with empty values
    const initialMapping: { [key: string]: string } = {};
    speakers.forEach(speaker => {
      initialMapping[speaker] = ""; // Default to empty for selection
    });
    setSpeakerMapping(initialMapping);
    setIsLoadingTranscript(false);
  };

  const extractSpeakersFromTranscript = (transcript: string[]): string[] => {
    const speakers = new Set<string>();
    transcript.forEach(line => {
      // Look for pattern "speaker:" at the beginning of line
      const match = line.match(/^([^:]+):/);
      if (match) {
        speakers.add(match[1].trim());
      }
    });
    return Array.from(speakers);
  };

  const handleSpeakerMappingChange = (originalSpeaker: string, newName: string) => {
    setSpeakerMapping(prev => ({
      ...prev,
      [originalSpeaker]: newName
    }));
    setValidationError(""); // Clear validation error when user makes changes
  };

  const validateMapping = () => {
    const mappedValues = Object.values(speakerMapping).filter(value => value !== "");
    const uniqueValues = new Set(mappedValues);

    // Check if all speakers are mapped
    const allMapped = Object.values(speakerMapping).every(value => value !== "");
    if (!allMapped) {
      setValidationError("Please map all speakers to names.");
      return false;
    }

    // Check for duplicates
    if (mappedValues.length !== uniqueValues.size) {
      setValidationError("Each speaker must be mapped to a different person. No duplicates allowed.");
      return false;
    }

    return true;
  };

  const handleSubmitMapping = () => {
    if (validateMapping()) {
      setIsMappingSubmitted(true);
      setValidationError("");
      toast.success("Speaker mapping submitted successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }
  };

  const getAvailableOptions = (currentSpeaker: string) => {
    const usedNames = Object.entries(speakerMapping)
      .filter(([speaker, name]) => speaker !== currentSpeaker && name !== "")
      .map(([, name]) => name);

    return availableNames.filter(name => !usedNames.includes(name));
  };

  const renderTranscriptWithMapping = () => {
    return transcriptData.map((line, index) => {
      const match = line.match(/^([^:]+):\s*(.*)$/);
      if (match) {
        const originalSpeaker = match[1].trim();
        const message = match[2].trim();
        const mappedSpeaker = isMappingSubmitted && speakerMapping[originalSpeaker]
          ? speakerMapping[originalSpeaker]
          : originalSpeaker;

        return (
          <Card key={index} className="mb-2">
            <CardBody className="py-2">
              <div className="d-flex">
                <strong className="text-primary me-2">{mappedSpeaker}:</strong>
                <span>{message}</span>
              </div>
            </CardBody>
          </Card>
        );
      } else {
        // Handle lines without speaker format
        return (
          <Card key={index} className="mb-2">
            <CardBody className="py-2">
              <span className="text-muted">{line}</span>
            </CardBody>
          </Card>
        );
      }
    });
  };
  const refreshModal32 = async (value: boolean) => {
    if (value) {
      const result = await fetchClinicalAssessmentWithVersions(clientId);
      if (result.success) {
        setClinicalAssessmentInfo(result.data);
      }
    }
  };
  return (
    <React.Fragment>
      {showNewClinicalAssessmentModal && <NewClinicalAssessmentModal showModal={showNewClinicalAssessmentModal} identifierId={clientId} setShowModal={setShowNewClinicalAssessmentModal} isFromMeeting={false} isAdmin={false} setModalRefresher={refreshModal32} aiGeneratedAssessmentData={null} isMeeting={false} />}
      {showClinicalAssessmentModal && <ClinicalAssetmentModal setShowModal={setShowClinicalAssessmentModal} showModal={showClinicalAssessmentModal} identifierId={clientId} isAdmin={false} isFromMeeting={false} setModalRefresher={refreshModal32} />}
      {showClinicalAssessmentPdfModal && <ClinicalAssessmentPdfModal setShowModal={setShowClinicalAssessmentPdfModal} showModal={showClinicalAssessmentPdfModal} identifierId={clinicalAssessmentId} isAdmin={false} eventType={eventType} insuranceDocApprovalId={null} setModalRefresher={null} clinicalAssessmentType={clinicalAssessmentType as TPType} />}
      {showNewClinicalAssessmentPdfModal && <NewClinicalAssessmentPdfModal setShowModal={setShowNewClinicalAssessmentPdfModal} showModal={showNewClinicalAssessmentPdfModal} identifierId={clinicalAssessmentId} isAdmin={false} eventType={eventType} insuranceDocApprovalId={null} setModalRefresher={null} digitalAssessmentType={clinicalAssessmentType as TPType} />}
      {showAiGeneratedAssessmentPopup && (
        <AIGeneratedAssessment
          OpenAiModel={showAiGeneratedAssessmentPopup}
          transcribeData={firstMeetingData}
          closeModelFunction={handleChildFunction}
          refreshModal32={refreshModal32}
          isInMeeting={false}
          clientId={clientId}
        />
      )}
      {showTestModal && (
        <Modal isOpen={showTestModal} toggle={closeTestModal} size="lg" centered>
          <ModalHeader toggle={closeTestModal}>Transcript Speaker Mapping</ModalHeader>
          <ModalBody>
            {isLoadingTranscript ? (
              <div className="text-center p-4">
                <Spinner className="bouncer" />
                <p className="mt-2">Loading transcript...</p>
              </div>
            ) : (
              <div>
                {/* Speaker Mapping Section */}
                {Object.keys(speakerMapping).length > 0 && !isMappingSubmitted && (
                  <div className="mb-4">
                    <h5 className="mb-3">Speaker Mapping</h5>
                    <p className="text-muted small mb-3">Map the original speakers to actual names:</p>

                    {validationError && (
                      <Alert color="danger" className="mb-3">
                        {validationError}
                      </Alert>
                    )}

                    {Object.keys(speakerMapping).map(originalSpeaker => (
                      <FormGroup key={originalSpeaker} className="row mb-3 align-items-center">
                        <div className="col-md-4">
                          <Label className="form-label mb-0">
                            <strong>{originalSpeaker}</strong> →
                          </Label>
                        </div>
                        <div className="col-md-8">
                          <Input
                            type="select"
                            value={speakerMapping[originalSpeaker]}
                            onChange={(e) => handleSpeakerMappingChange(originalSpeaker, e.target.value)}
                            className="form-control-sm"
                          >
                            <option value="">Select a person...</option>
                            {getAvailableOptions(originalSpeaker).map(name => (
                              <option key={name} value={name}>{name}</option>
                            ))}
                            {speakerMapping[originalSpeaker] && !getAvailableOptions(originalSpeaker).includes(speakerMapping[originalSpeaker]) && (
                              <option value={speakerMapping[originalSpeaker]}>{speakerMapping[originalSpeaker]}</option>
                            )}
                          </Input>
                        </div>
                      </FormGroup>
                    ))}

                    <div className="text-center mt-4">
                      <Button
                        color="primary"
                        onClick={handleSubmitMapping}
                        className="px-4"
                      >
                        Submit Mapping
                      </Button>
                    </div>
                    <hr className="my-4" />
                  </div>
                )}

                {/* Show mapping summary after submission */}
                {isMappingSubmitted && (
                  <div className="mb-4">
                    <h5 className="mb-3">Speaker Mapping Applied</h5>
                    <div className="bg-light p-3 rounded">
                      {Object.entries(speakerMapping).map(([original, mapped]) => (
                        <div key={original} className="d-flex justify-content-between mb-1">
                          <span><strong>{original}</strong></span>
                          <span className="text-primary">{mapped}</span>
                        </div>
                      ))}
                    </div>
                    <div className="text-center mt-3">
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => setIsMappingSubmitted(false)}
                      >
                        Edit Mapping
                      </Button>
                    </div>
                    <hr className="my-4" />
                  </div>
                )}

                {/* Transcript Display Section */}
                <div>
                  <h5 className="mb-3">Transcript</h5>
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {renderTranscriptWithMapping()}
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}
      <div style={{ padding: '10px', maxWidth: '100%' }}>
        <h3 className="mb-4" style={{ color: "#f27e0c", marginTop: "3px" }}>Clinical Assessment With Amendments</h3>
        {/* <Button
          color="secondary"
          className="ml-3 btn-black1 convert-pending-note s-h-btn"
          onClick={handleAIGenerateClick}
          disabled={isLoading}
        >
          <img src={AiIcon} className="ai-icon-size me-1" />
          Generate Clinical Assessment With AI
        </Button> */}
        {(!isAdmin && clinicalAssessmentInfo?.length === 0) && (
          <div className="d-flex justify-content-center mb-4">
            <Button color="primary" className="py-2 shadow-sm s-h-btn" onClick={openClinicalAssessment}>
              <i className="fa fa-plus mr-2"></i> Create Clinical Assessment
            </Button>
            {((firstMeetingData &&
              firstMeetingData?.clientAllowedTranscribe &&
              firstMeetingData?.therapistAllowedTranscribe &&
              firstMeetingData?.firstSpeaker &&
              firstMeetingData?.transcribeCreated || loggedUser?._id == "62f17eb1b81f31a68505d9ad"
            )
              ) && (
                <Button
                  color="secondary"
                  className="ml-3 btn-black1 convert-pending-note s-h-btn"
                  onClick={handleAIGenerateClick}
                  disabled={isLoading}
                >
                  <img src={AiIcon} className="ai-icon-size me-1" />
                  Generate Clinical Assessment With AI
                </Button>
              )}
          </div>
        )}


        {(isMobile && clinicalAssessmentInfo?.length > 0) ? (<span className="text-muted small"><mark>Note: To view or download the amendment, please use a laptop or desktop computer.</mark></span>) : (<></>)}
        {isLoading ? (
          <div className={"d-flex justify-content-center align-items-center"} style={{minHeight:"25vh",width:"100%",position:"relative"}}>
            <Spinner className={"bouncer"} />
          </div>
        ) : (
          <>
            {clinicalAssessmentInfo?.length > 0 ? (
              clinicalAssessmentInfo.map((plan: any) => (
                <div key={plan?._id} className="therapy-plan-item mb-4 bg-light rounded p-3 shadow-sm">
                  <h5 className="font-weight-bold text-dark">Clinical Assessment</h5>
                  <p className="text-muted small mb-3">Created date: {formatDate(plan?.createdAt)}</p>

                  <div className="therapy-plan-buttons mb-3">
                    <div className="d-flex flex-wrap align-items-center justify-content-start gap-2">
                      {!isAdmin && (
                        <Button color="success" onClick={openClinicalAssessment} className="btn-sm shadow-sm">
                          <i className="fa fa-file mr-1"></i> Open / Edit
                        </Button>
                      )}
                      {(!isMobile) && (
                        <Button color="info" onClick={() => generateClinicalPdf(plan?._id, TPType.ORIGINAL)} className="btn-sm shadow-sm">
                          <i className="fa fa-download mr-1"></i> Download
                        </Button>
                      )}
                      {((firstMeetingData2 &&
                        firstMeetingData2?.clientAllowedTranscribe &&
                        firstMeetingData2?.therapistAllowedTranscribe &&
                        firstMeetingData2?.firstSpeaker &&
                        firstMeetingData2?.transcribeCreated &&
                        (!plan?.versions || plan?.versions.length === 0)
                        || loggedUser?._id == "62f17eb1b81f31a68505d9ad"
                      )
                        ) && (
                          <Button
                            color="secondary"
                            className="btn-black1 convert-pending-note btn-sm shadow-sm"
                            onClick={handleReGenerateAIClick}
                            disabled={isLoading}
                          >
                            <img src={AiIcon} className="ai-icon-size me-1" />
                            Re-Generate Clinical Assessment With AI
                          </Button>
                        )}
                    </div>
                  </div>

                  {plan?.versions && plan?.versions.length > 0 ? (
                    <div className="therapy-plan-versions mt-3">
                      <Button
                        color="link"
                        onClick={() => toggleVersions(plan?._id)}
                        className="p-0 text-decoration-none"
                      >
                        <h6 className="font-weight-bold mb-0">
                          {expandedPlans[plan?._id] ? 'Hide' : 'View'} amendments {' '}
                          <i className={`fa fa-chevron-${expandedPlans[plan?._id] ? 'up' : 'down'}`} />
                        </h6>
                      </Button>
                      <Collapse isOpen={expandedPlans[plan?._id]}>
                        <ul className="list-unstyled mt-2">
                          {plan?.versions.map((version: any, versionIndex: number) => (
                            <li key={version?._id} className="mb-2 bg-white p-2 rounded shadow-sm">
                              <span className="font-weight-medium">Amendment {versionIndex + 1}</span><br />
                              <span className="text-muted small">Created date: <b>{formatDate(version?.versionCreatedAt)}</b></span><br />
                              <span className="text-muted small">Amendment modified due to: <b>{version?.reasonForEdit}</b></span><br />
                              {(!isMobile) && (
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => generateClinicalPdf(version?._id, TPType.VERSION)}
                                  className="mt-2 shadow-sm"
                                >
                                  View / Download
                                </Button>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </div>
                  ) : (
                    <p className="text-muted font-italic">No amendments available.</p>
                  )}
                </div>
              ))
            ) : (
              <p className="text-center text-muted font-italic">No clinical assessment available.</p>
            )}
          </>
          )}

      </div>
    </React.Fragment>
  );
};

export default AssessmentClientSaas;
